var React = require('react');

function GreenArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.86603 6.5C4.48113 7.16667 3.51887 7.16667 3.13397 6.5L0.535898 2C0.150998 1.33333 0.632122 0.500001 1.40192 0.500001L6.59807 0.5C7.36788 0.5 7.849 1.33333 7.4641 2L4.86603 6.5Z","fill":"#44B04F"}));
}

GreenArrow.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7","fill":"none"};

module.exports = GreenArrow;

GreenArrow.default = GreenArrow;
